export default "__VITE_ASSET__BlwB2kBF__"